// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pcvrDNbZglcPJenW1wq5{background-color:var(--background-primary-inverted-primary);flex-direction:column;width:100%;height:100vh;display:flex}.pcvrDNbZglcPJenW1wq5 .aqsIDwxiIcd0vZE97qac{text-align:center}.t3hIGYJImeEF7oLPyPGG{height:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `pcvrDNbZglcPJenW1wq5`,
	"subtitle": `aqsIDwxiIcd0vZE97qac`,
	"successWrap": `t3hIGYJImeEF7oLPyPGG`
};
export default ___CSS_LOADER_EXPORT___;
